import { formatBigNumber } from '@/components/filters'

const category = {
  all: 'all',
  sent: 'sent',
  realSent: 'real_sent',
  micrositePV: 'microsite_pv',
  jobPV: 'job_pv',
  applied: 'applied',
  screened: 'screened',
  interviewed: 'interviewed',
  hired: 'hired'
}

const categoryChartOption = {
  dataset: {
    dimensions: ['category', 'value'],
    source: []
  },
  tooltip: {
    trigger: 'axis'
  },
  grid: {
    top: '10%',
    left: '2%',
    right: '2%',
    bottom: '2%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    show: false
  },
  yAxis: [
    {
      type: 'category',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false,
        alignWithLabel: true
      },
      splitLine: {
        show: true
      }
    },
    {
      type: 'category',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false,
        alignWithLabel: true
      },
      axisLabel: {
        formatter: (data) => formatBigNumber(data)
      }
    }
  ],
  series: [
    {
      type: 'line',
      yAxisIndex: 0,
      symbol: 'circle',
      symbolSize: 5,
      showSymbol: true,
      color: '#badbf4',
      areaStyle: {
        color: '#badbf4'
      }
    },
    {
      type: 'line',
      yAxisIndex: 1
    }
  ]
}

const dateChartOption = {
  dataset: {
    source: []
  },
  dataZoom: [
    {
      type: 'slider',
      show: true,
      xAxisIndex: [0]
    },
    {
      type: 'slider',
      show: true,
      yAxisIndex: [0],
      left: '93%'
    },
    {
      type: 'inside',
      xAxisIndex: [0]
    },
    {
      type: 'inside',
      yAxisIndex: [0]
    }
  ],
  tooltip: {
    trigger: 'axis'
  },
  grid: {
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    axisLine: {
      show: false
    },
    axisTick: {
      show: false,
      alignWithLabel: true
    },
    offset: 10
  },
  yAxis: {
    type: 'value',
    axisLine: {
      show: false
    },
    axisTick: {
      show: false,
      alignWithLabel: true
    },
    offset: 10,
    splitLine: {
      show: true
    }
  },
  series: [
    {
      type: 'line',
      symbol: 'circle',
      symbolSize: 5,
      showSymbol: true,
      color: '#badbf4',
      areaStyle: {
        color: '#badbf4'
      },
      smooth: true
    }
  ]
}

export { category, categoryChartOption, dateChartOption }
